// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles

(function (modules, entry, mainEntry, parcelRequireName, globalName) {
  /* eslint-disable no-undef */
  var globalObject =
    typeof globalThis !== 'undefined'
      ? globalThis
      : typeof self !== 'undefined'
      ? self
      : typeof window !== 'undefined'
      ? window
      : typeof global !== 'undefined'
      ? global
      : {};
  /* eslint-enable no-undef */

  // Save the require from previous bundle to this closure if any
  var previousRequire =
    typeof globalObject[parcelRequireName] === 'function' &&
    globalObject[parcelRequireName];

  var cache = previousRequire.cache || {};
  // Do not use `require` to prevent Webpack from trying to bundle this call
  var nodeRequire =
    typeof module !== 'undefined' &&
    typeof module.require === 'function' &&
    module.require.bind(module);

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire =
          typeof globalObject[parcelRequireName] === 'function' &&
          globalObject[parcelRequireName];
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error("Cannot find module '" + name + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = (cache[name] = new newRequire.Module(name));

      modules[name][0].call(
        module.exports,
        localRequire,
        module,
        module.exports,
        this
      );
    }

    return cache[name].exports;

    function localRequire(x) {
      var res = localRequire.resolve(x);
      return res === false ? {} : newRequire(res);
    }

    function resolve(x) {
      var id = modules[name][1][x];
      return id != null ? id : x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.register = function (id, exports) {
    modules[id] = [
      function (require, module) {
        module.exports = exports;
      },
      {},
    ];
  };

  Object.defineProperty(newRequire, 'root', {
    get: function () {
      return globalObject[parcelRequireName];
    },
  });

  globalObject[parcelRequireName] = newRequire;

  for (var i = 0; i < entry.length; i++) {
    newRequire(entry[i]);
  }

  if (mainEntry) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(mainEntry);

    // CommonJS
    if (typeof exports === 'object' && typeof module !== 'undefined') {
      module.exports = mainExports;

      // RequireJS
    } else if (typeof define === 'function' && define.amd) {
      define(function () {
        return mainExports;
      });

      // <script>
    } else if (globalName) {
      this[globalName] = mainExports;
    }
  }
})({"fgkIw":[function(require,module,exports) {
require("59b73415d12e6428").register(JSON.parse('{"fRtTy":"group.a178b09a.js","k8qgN":"user.63573a06.svg","k5CRO":"img.0cba27bb.svg","4ZR27":"group.d69aee80.svg","ckW5F":"index.919a24ef.js","ikhXE":"index.36bc93d7.js"}'));

},{"59b73415d12e6428":"fyJL2"}],"fyJL2":[function(require,module,exports) {
"use strict";
var mapping = {};
function register(pairs) {
    var keys = Object.keys(pairs);
    for(var i = 0; i < keys.length; i++)mapping[keys[i]] = pairs[keys[i]];
}
function resolve(id) {
    var resolved = mapping[id];
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return resolved;
}
module.exports.register = register;
module.exports.resolve = resolve;

},{}],"3Gn2A":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
var _auth = require("firebase/auth");
var _common = require("./common");
var _config = require("./config");
var _database = require("firebase/database");
var _groupSvg = require("url:../images/group.svg");
var _groupSvgDefault = parcelHelpers.interopDefault(_groupSvg);
var _userSvg = require("url:../images/user.svg");
var _userSvgDefault = parcelHelpers.interopDefault(_userSvg);
var _imgSvg = require("../images/img.svg");
var _imgSvgDefault = parcelHelpers.interopDefault(_imgSvg);
"use strict";
let lang;
let group, teamId;
let groupId;
let tabs;
let frags;
let ivIcon, dName, dDesc;
let user, userInfo, role;
let dEventList, dPlayerList, dRsvpPlayerList;
let dStaffList, dMemberList;
let dNoPeople;
let playerKeyList = [];
let dbUser, dbRole;
let dbGroup;
let dbEvents, dbTeam, dbChat, dbMsg, dbUchat;
let dbPlayers, dbPlayer, dbStaff, dbMembers, dbJoined;
let dbPRsvp, dbPlayerGoingCount;
let currentPerson = 0;
let dGroup404, dLoadingModal, dRsvp;
let dbUserGoingCount, dbURsvp;
let activeEvent;
let dMsgList, dEmptyMsg;
let btnSendMsg, inMsg;
$(document).ready(function() {
    $(function() {
        (0, _common.initFooter)();
        initLangUi();
        initUi();
        getUser();
    });
});
function initLangUi() {
    lang = (0, _common.initLangCookie)();
    (0, _common.initLangAction)();
}
function initUi() {
    ivIcon = document.getElementById("ivIcon");
    dName = document.getElementById("gName");
    dDesc = document.getElementById("gDesc");
    tabs = document.getElementById("tabs").querySelectorAll("div");
    frags = document.querySelectorAll(".g-frag");
    dEventList = document.getElementById("dEventList");
    dPlayerList = document.getElementById("dPlayerList");
    dRsvpPlayerList = document.getElementById("dRsvpPlayers");
    dGroup404 = document.getElementById("dGroup404");
    dLoadingModal = document.getElementById("dLoadingModal");
    dRsvp = document.getElementById("dRsvp");
    dStaffList = document.getElementById("dStaffList");
    dMemberList = document.getElementById("dMemberList");
    dMsgList = document.querySelector("#dChat .msg-list");
    dEmptyMsg = document.querySelector("#dChat .empty");
}
function getUser() {
    (0, _common.setDisplay)(dLoadingModal, "flex");
    let auth = (0, _config.initAuth);
    let startLs = true;
    (0, _auth.onAuthStateChanged)(auth, (data)=>{
        user = data;
        if (user) getUserInfo();
        if (startLs) {
            startLs = false;
            initLs();
        }
    });
}
function getUserInfo() {
    dbUser = (0, _database.ref)((0, _config.db), `user/${user.uid}`);
    (0, _database.onValue)(dbUser, (data)=>{
        if (data.exists()) userInfo = data.val();
        else userInfo = null;
        initRsvpUi();
    }, {
        onlyOnce: true
    });
}
function initRsvpUi() {
    let rsvpUser = dRsvp.querySelector("#dRsvpStaff .rsvp");
    let imgUser = rsvpUser.querySelector("img");
    let dName = rsvpUser.querySelector(".name");
    $(imgUser).on("error", function() {
        imgUser.src = (0, _userSvgDefault.default);
    });
    if (userInfo) {
        imgUser.src = userInfo.imgUrl ? userInfo.imgUrl : (0, _userSvgDefault.default);
        dName.textContent = `${userInfo.name} (You)`;
    } else (0, _common.setDisplay)(rsvpUser, "none");
}
function initLs() {
    let search = window.location.search.replace("?", "").replaceAll("+", " ");
    let url = decodeURIComponent(window.location.href);
    if (url.indexOf("group/") > -1) {
        let groupName = url.substring(url.lastIndexOf("/") + 1).replaceAll("+", " ");
        findGroup(groupName);
    } else if (search) findGroup(search);
    dRsvp.querySelector(".btn-close").addEventListener("click", function(event) {
        (0, _common.setDisplay)(dRsvp, "none");
        resetRsvpLs();
    });
}
function resetRsvpLs() {
    activeEvent = null;
    if (dbURsvp) (0, _database.off)(dbURsvp);
    if (dbUserGoingCount) (0, _database.off)(dbUserGoingCount);
    if (dbPRsvp) for(let index = 0; index < playerKeyList.length; index++){
        const playerId = playerKeyList[index];
        (0, _database.off)((0, _database.child)(dbPRsvp, `${playerId}`));
    }
    if (dbPlayerGoingCount) (0, _database.off)(dbPlayerGoingCount);
}
function findGroup(name) {
    let dbSearch = (0, _database.ref)((0, _config.db), `gLink/${name}`);
    (0, _database.onValue)(dbSearch, (data)=>{
        if (data.exists()) {
            groupId = data.val();
            if (groupId != null) initRoleLs();
            else (0, _common.setDisplay)(dGroup404, "flex");
        } else {
            groupId = null;
            (0, _common.setDisplay)(dGroup404, "flex");
        }
    }, {
        onlyOnce: true
    });
}
function initRoleLs() {
    let btnEdit = dRsvp.querySelector(".btn-rs-edit");
    if (user) {
        dbRole = (0, _database.ref)((0, _config.db), `role/${groupId}/${user.uid}`);
        (0, _database.onValue)(dbRole, (data)=>{
            if (data.exists()) role = data.val();
            else setDefRole();
            (0, _common.setDisplay)(btnEdit, role.owner || role.staff ? "block" : "none");
            initGroupLs();
        });
    } else {
        setDefRole();
        (0, _common.setDisplay)(btnEdit, "none");
        initGroupLs();
    }
}
function initGroupLs() {
    let startfrags = true;
    dbGroup = (0, _database.ref)((0, _config.db), `group/${groupId}`);
    (0, _database.onValue)(dbGroup, (data)=>{
        (0, _common.setDisplay)(dLoadingModal, "none");
        if (data.exists()) {
            group = data.val();
            if (group != null) {
                updateGroupUi();
                if (startfrags) {
                    startfrags = false;
                    initFrags();
                }
            } else (0, _common.setDisplay)(dGroup404, "flex");
        } else (0, _common.setDisplay)(dGroup404, "flex");
    });
}
function setDefRole() {
    role = {
        admin: false,
        coach: false,
        member: false,
        owner: false,
        staff: false
    };
}
function updateGroupUi() {
    $(ivIcon).on("error", function() {
        ivIcon.src = (0, _groupSvgDefault.default);
    });
    ivIcon.src = group.imgUrl ? group.imgUrl : (0, _groupSvgDefault.default);
    dName.textContent = group.name;
    dDesc.textContent = group.desc;
}
function initFrags() {
    let current = 0;
    initEventFrag();
    for(let index = 0; index < tabs.length; index++){
        const tab = tabs[index];
        $(tab).click(function() {
            if (index == 2 && (!user || !role.member)) {
                //is chat
                if (!user) (0, _common.confirmLoginModal)("Register or login to participate in the chat", `?g=${group.name}`);
                else (0, _common.showConfirmModal)("Join group", "You are not a part of this group yet. Would you like to join this group?", joinGroup);
                return;
            }
            tabs[current].classList.remove("selected");
            (0, _common.setDisplay)(frags[current], "none");
            (0, _common.setDisplay)(frags[index], "flex");
            tabs[index].classList.add("selected");
            current = index;
            initFragLs(index);
        });
    }
}
function initFragLs(index) {
    switch(index){
        case 0:
            if (dbEvents == null) initEventFrag();
            break;
        case 1:
            if (dbTeam == null) initTeamFrag();
            break;
        default:
            initChatFrag();
            break;
    }
}
function initEventFrag() {
    dbEvents = (0, _database.ref)((0, _config.db), `event/${groupId}`);
    let dNone = document.querySelector("#dEvents .dNone");
    (0, _database.onChildAdded)(dbEvents, (data)=>{
        (0, _common.setDisplay)(dNone, "none");
        addEvent(dEventList, data.key, data.val());
    });
    (0, _database.onChildChanged)(dbEvents, (data)=>{
        addEvent(dEventList, data.key, data.val());
    });
    (0, _database.onChildRemoved)(dbEvents, (data)=>{
        removeElement(data.key);
        if (dEventList.children.length == 0) (0, _common.setDisplay)(dNone, "flex");
    });
}
function removeElement(id) {
    let e = document.getElementById(id);
    if (e) e.remove();
}
function addEvent(parent, key, event) {
    var dOld = document.getElementById(key);
    const container = document.createElement("div");
    container.innerHTML = (0, _common.list_event);
    const div = container.firstChild;
    div.setAttribute("id", key);
    let dDate = div.querySelector(".dDate");
    let dTime = div.querySelector(".dTime");
    let dArrive = div.querySelector(".dArrive");
    let spArrive = div.querySelector(".dArrive span");
    let dType = div.querySelector(".dType");
    let dLocation = div.querySelector(".dLocation");
    let aLocation = div.querySelector(".aLoc");
    let dNotes = div.querySelector(".dNotes");
    let btnRsvp = div.querySelector(".btnRsvp");
    let start = (0, _common.formatTime)(event.start);
    dDate.innerHTML = (0, _common.formatDate)(event.start, false);
    let end = event.end ? (0, _common.formatTime)(event.end) : null;
    if (end) dTime.textContent = `${start} - ${end}`;
    else dTime.textContent = start;
    if (event.arrive != 0) {
        (0, _common.setDisplay)(dArrive, "block");
        spArrive.textContent = (0, _common.formatTime)(event.arrive);
    } else (0, _common.setDisplay)(dArrive, "none");
    dType.textContent = event.type;
    if (event.loc) {
        aLocation.innerHTML = event.loc;
        aLocation.href = (0, _common.getMapLink)(event.loc);
        (0, _common.setDisplay)(dLocation, "-webkit-box");
    } else (0, _common.setDisplay)(dLocation, "none");
    if (event.notes) {
        dNotes.textContent = event.notes;
        (0, _common.setDisplay)(dNotes, "block");
    } else (0, _common.setDisplay)(dNotes, "none");
    $(btnRsvp).off("click");
    $(btnRsvp).on("click", function() {
        initRsvpModal(key, event);
    });
    if (dOld) parent.replaceChild(div, dOld);
    else parent.appendChild(div);
}
function initRsvpModal(key, event) {
    (0, _common.setDisplay)(dRsvp, "flex");
    activeEvent = key;
    let btnEdit = dRsvp.querySelector(".btn-rs-edit");
    let rsDate = dRsvp.querySelector(".rs-date");
    let rsType = dRsvp.querySelector(".rs-type");
    let spArrive = dRsvp.querySelector(".sp-arrive");
    let rsArrive = dRsvp.querySelector(".rs-arrive");
    let rsTime = dRsvp.querySelector(".rs-time");
    let aLoc = dRsvp.querySelector(".rs-loc");
    let spLoc = dRsvp.querySelector(".rs-loc span");
    let rsNotes = dRsvp.querySelector(".rs-notes");
    let rbUserYes = document.getElementById("radYes");
    let rbUserNo = document.getElementById("radNo");
    let rbUserMaybe = document.getElementById("radMaybe");
    let rsStaffYesCount = dRsvp.querySelector(".rs-staff-yes span");
    let rsStaffNoCount = dRsvp.querySelector(".rs-staff-no span");
    let rsPlayerYesCount = dRsvp.querySelector(".rs-player-yes span");
    let rsPlayerNoCount = dRsvp.querySelector(".rs-player-no span");
    //let rgGoing = dRsvp.querySelectorAll('#dRsvpStaff input[name="rsvp"]');
    $(btnEdit).off("click");
    $(btnEdit).on("click", function() {
    //TODO: show edit rsvp modal
    });
    rsDate.innerHTML = (0, _common.formatDate)(event.start, true);
    rsType.textContent = event.type;
    if (event.arrive != 0) {
        (0, _common.setDisplay)(rsArrive, "block");
        spArrive.textContent = (0, _common.formatTime)(event.arrive);
    } else (0, _common.setDisplay)(rsArrive, "none");
    let start = (0, _common.formatTime)(event.start);
    let end = event.end ? (0, _common.formatTime)(event.end) : null;
    if (end) rsTime.textContent = `${start} - ${end}`;
    else rsTime.textContent = start;
    if (event.loc) {
        spLoc.innerHTML = event.loc;
        aLoc.href = (0, _common.getMapLink)(event.loc);
        (0, _common.setDisplay)(aLoc, "block");
    } else (0, _common.setDisplay)(aLoc, "none");
    if (event.notes) {
        rsNotes.textContent = event.notes;
        (0, _common.setDisplay)(rsNotes, "block");
    } else (0, _common.setDisplay)(rsNotes, "none");
    if (dbPlayers == null) loadPlayers(key);
    else for(let index = 0; index < playerKeyList.length; index++){
        const playerId = playerKeyList[index];
        getPlayerRsvp(playerId, key);
    }
    //User rsvp listeners
    $(rbUserYes).off("click");
    $(rbUserNo).off("click");
    $(rbUserMaybe).off("click");
    let rgGoing = [];
    rgGoing.push(rbUserYes);
    rgGoing.push(rbUserNo);
    rgGoing.push(rbUserMaybe);
    if (user) {
        dbURsvp = (0, _database.ref)((0, _config.db), `uRsvp/${key}/${user.uid}`);
        (0, _database.onValue)(dbURsvp, (data)=>{
            if (data.exists()) {
                let going = data.val();
                if (going) rbUserYes.checked = true;
                else rbUserNo.checked = true;
            } else rbUserMaybe.checked = true;
        });
        dbUserGoingCount = (0, _database.ref)((0, _config.db), `userRsvpCount/${key}`);
        (0, _database.onValue)(dbUserGoingCount, (data)=>{
            let rsvp = null;
            if (data.exists()) rsvp = data.val();
            rsStaffYesCount.textContent = rsvp != null ? rsvp.yes : "0";
            rsStaffNoCount.textContent = rsvp != null ? rsvp.no : "0";
        });
        dbPlayerGoingCount = (0, _database.ref)((0, _config.db), `playerRsvpCount/${key}`);
        (0, _database.onValue)(dbPlayerGoingCount, (data)=>{
            let rsvp = null;
            if (data.exists()) rsvp = data.val();
            rsPlayerYesCount.textContent = rsvp != null ? rsvp.yes : "0";
            rsPlayerNoCount.textContent = rsvp != null ? rsvp.no : "0";
        });
    }
    for(let index = 0; index < rgGoing.length; index++){
        const rb = rgGoing[index];
        rb.addEventListener("change", function(event) {
            let checked = event.target.value;
            if (checked && event.isTrusted) {
                if (user && role.member) rsvp(user.uid, checked, false);
                else {
                    rbUserMaybe.checked = true;
                    if (!user) (0, _common.confirmLoginModal)("Register or login to RSVP", `?g=${group.name}`);
                    else (0, _common.showConfirmModal)("Join group", "You are not a part of this group yet. Would you like to join this group?", joinGroup);
                }
            }
        });
    }
}
function joinGroup() {
    const dbMembers = (0, _database.ref)((0, _config.db), `members/${groupId}`);
    if (dbJoined == null) dbJoined = (0, _database.ref)((0, _config.db), `joined/${user.uid}/${groupId}`);
    const date = new Date().getTime();
    (0, _database.set)((0, _database.child)(dbRole, `member`), true).then(()=>{
        (0, _database.set)((0, _database.child)(dbMembers, user.uid), date).then(()=>{
            (0, _database.set)(dbJoined, date).then(()=>{
                (0, _common.showToast)("success", "Joined successfully!");
            });
        });
    }).catch((e)=>{
        (0, _common.showToast)("error", "Could not join group");
    });
}
function loadPlayers(eventId) {
    if (dbPlayers) (0, _database.off)(dbPlayers);
    teamId = group.team != null ? group.team : groupId;
    dbPlayers = (0, _database.ref)((0, _config.db), `players/${teamId}`);
    (0, _database.onChildAdded)(dbPlayers, (data)=>{
        getPlayerInfo(data.key, eventId);
    });
}
function getPlayerInfo(key, eventId) {
    let rsvpNoPlayers = document.getElementById("rsvpNoPlayers");
    if (dbPlayer == null) dbPlayer = (0, _database.ref)((0, _config.db), `player`);
    (0, _database.onValue)((0, _database.child)(dbPlayer, `${key}`), (data)=>{
        let player;
        if (data.exists()) {
            player = data.val();
            if (player) {
                playerKeyList.push(key);
                addPlayer(key, player, dPlayerList);
                addPlayerRsvp(key, player, dRsvpPlayerList, eventId);
                if (currentPerson == 0) (0, _common.setDisplay)(dNoPeople, "none");
                (0, _common.setDisplay)(rsvpNoPlayers, "none");
            }
        }
    }, {
        onlyOnce: true
    });
}
function addPlayer(key, player, parent) {
    var dOld = document.getElementById(key);
    const container = document.createElement("div");
    container.innerHTML = (0, _common.list_player);
    const div = container.firstChild;
    div.setAttribute("id", key);
    let btnEdit = div.querySelector(".btn-edit");
    let imgPlayer = div.querySelector(".img-player");
    let btnRemove = div.querySelector(".btn-remove");
    let dName = div.querySelector(".dName");
    let dNum = div.querySelector(".dNum");
    let dPos = div.querySelector(".dPos");
    if (!role.owner) {
        (0, _common.setDisplay)(btnEdit, "none");
        (0, _common.setDisplay)(btnRemove, "none");
    }
    $(imgPlayer).on("error", function() {
        imgPlayer.src = (0, _userSvgDefault.default);
    });
    $(btnEdit).off("click");
    $(btnRemove).off("click");
    $(btnEdit).on("click", function() {
    //TODO: edip player modal
    });
    $(btnEdit).on("click", function() {
    //TODO: confirm remove player
    });
    imgPlayer.src = player.imgUrl ? player.imgUrl : (0, _userSvgDefault.default);
    dName.textContent = player.name;
    dNum.textContent = player.num;
    dPos.textContent = (0, _common.getPlayerPos)(player.pos);
    if (dOld) parent.replaceChild(div, dOld);
    else parent.appendChild(div);
}
function addPlayerRsvp(key, player, parent, eventId) {
    let eId = `${key}Rsvp`;
    var dOld = document.getElementById(eId);
    const container = document.createElement("div");
    container.innerHTML = (0, _common.list_rsvp);
    const div = container.firstChild;
    div.setAttribute("id", eId);
    let imgPlayer = div.querySelector(".img-player");
    let dName = div.querySelector(".name");
    let rgRsvp = div.querySelectorAll('input[name="rsvp"]');
    let lblList = div.querySelectorAll("label");
    let rbIdList = [
        `rbYes${key}`,
        `rbNo${key}`,
        `rbMaybe${key}`
    ];
    $(imgPlayer).on("error", function() {
        imgPlayer.src = (0, _userSvgDefault.default);
    });
    imgPlayer.src = player.imgUrl ? player.imgUrl : (0, _userSvgDefault.default);
    dName.textContent = player.name;
    for(let index = 0; index < rgRsvp.length; index++){
        const rbGoing = rgRsvp[index];
        rbGoing.name = key;
        rbGoing.id = rbIdList[index];
        lblList[index].htmlFor = rbIdList[index];
        rbGoing.addEventListener("change", function(event) {
            let checked = event.target.value;
            if (checked && event.isTrusted) {
                if (user && role.member) rsvp(key, checked, true);
                else {
                    rgRsvp[2].checked = true;
                    if (!user) (0, _common.confirmLoginModal)("Register or login to RSVP", `?g=${group.name}`);
                    else (0, _common.showConfirmModal)("Join group", "You are not a part of this group yet. Would you like to join this group?", joinGroup);
                }
            }
        });
    }
    if (dOld) parent.replaceChild(div, dOld);
    else {
        parent.appendChild(div);
        if (eventId) getPlayerRsvp(key, eventId);
    }
}
function rsvp(uid, isGoing, isPlayer) {
    if (activeEvent == null) return;
    let path = isPlayer ? `pRsvp/${activeEvent}/${uid}` : `uRsvp/${activeEvent}/${uid}`;
    let dbRsvp = (0, _database.ref)((0, _config.db), path);
    if (isGoing == "maybe") (0, _database.remove)(dbRsvp).then(()=>{
        (0, _common.showToast)("success", "RSVP removed");
    }).catch((e)=>{
        (0, _common.showToast)("error", "Something went wrong. Try again later.");
    });
    else {
        let val = isGoing == "yes";
        (0, _database.set)(dbRsvp, val).then(()=>{
            (0, _common.showToast)("success", "RSVP updated!");
        }).catch((e)=>{
            (0, _common.showToast)("error", "Something went wrong. Try again later.");
        });
    }
}
function getPlayerRsvp(key, eventId) {
    let rbYes = document.getElementById(`rbYes${key}`);
    if (!rbYes) return;
    let rbNo = document.getElementById(`rbNo${key}`);
    let rbMaybe = document.getElementById(`rbMaybe${key}`);
    if (dbPRsvp == null) dbPRsvp = (0, _database.ref)((0, _config.db), `pRsvp/${eventId}`);
    (0, _database.onValue)((0, _database.child)(dbPRsvp, `${key}`), (data)=>{
        if (playerKeyList.includes(key)) {
            let n = 2; // maybe
            if (data.exists()) {
                let going = data.val();
                if (going != null) n = going ? 1 : 0;
            }
            switch(n){
                case 0:
                    rbNo.checked = true;
                    break;
                case 1:
                    rbYes.checked = true;
                    break;
                default:
                    rbMaybe.checked = true;
                    break;
            }
        } else (0, _database.off)((0, _database.child)(dbPRsvp, `${key}`));
    });
}
function initTeamFrag() {
    dbTeam = (0, _database.ref)((0, _config.db), `team`);
    dNoPeople = document.getElementById("dNoPeople");
    let btnAddPerson = document.getElementById("btnAddPerson");
    let rgPeople = document.querySelectorAll('#dTeamOptions input[name="people"]');
    let peopleList = document.querySelectorAll(".t-people");
    let btnNameList = [
        "Add player",
        "Add staff",
        "Invite member"
    ];
    initPlayerFrag();
    for(let index = 0; index < rgPeople.length; index++){
        const rb = rgPeople[index];
        rb.addEventListener("change", function(event) {
            let checked = event.target.value;
            if (checked) {
                peopleList[index].classList.add("selected");
                peopleList[currentPerson].classList.remove("selected");
                btnAddPerson.querySelector("span").textContent = btnNameList[index];
                currentPerson = index;
                //TODO: init person frag
                // loadPlayers()
                initPeopleFrags(checked);
            }
        });
    }
    $(btnAddPerson).click(function() {
        addRole();
    });
}
function initPeopleFrags(type) {
    switch(type){
        case "players":
            initPlayerFrag();
            break;
        case "staff":
            initStaffFrag();
            break;
        default:
            initMemberFrag();
            break;
    }
}
function initPlayerFrag() {
    (0, _common.setDisplay)(dNoPeople, dPlayerList.children.length == 0 ? "flex" : "none");
    dNoPeople.querySelector("p").textContent = user ? "No players yet" : "Login to view this information";
    if (user && dbPlayers == null) loadPlayers();
}
function initStaffFrag() {
    (0, _common.setDisplay)(dNoPeople, dStaffList.children.length == 0 ? "flex" : "none");
    dNoPeople.querySelector("p").textContent = user ? "No staff yet" : "Login to view this information";
    if (!user || dbStaff) return;
    dbStaff = (0, _database.ref)((0, _config.db), `staff/${groupId}`);
    (0, _database.onChildAdded)(dbStaff, (data)=>{
        getPersonInfo("staff", data.key, dStaffList);
    });
    (0, _database.onChildRemoved)(dbStaff, (data)=>{
        removeElement(`staff${data.key}`);
        if (currentPerson == 1 && dStaffList.children.length == 0) (0, _common.setDisplay)(dNoPeople, "flex");
    });
}
function initMemberFrag() {
    (0, _common.setDisplay)(dNoPeople, dMemberList.children.length == 0 ? "flex" : "none");
    dNoPeople.querySelector("p").textContent = user ? "No members yet" : "Login to view this information";
    if (!user || dbMembers) return;
    dbMembers = (0, _database.ref)((0, _config.db), `members/${groupId}`);
    (0, _database.onChildAdded)(dbMembers, (data)=>{
        getPersonInfo("member", data.key, dMemberList);
    });
    (0, _database.onChildRemoved)(dbMembers, (data)=>{
        removeElement(`member${data.key}`);
        if (currentPerson == 2 && dMemberList.children.length == 0) (0, _common.setDisplay)(dNoPeople, "flex");
    });
}
function getPersonInfo(type, key, parent) {
    let dbUser = (0, _database.ref)((0, _config.db), `user/${key}`);
    (0, _database.onValue)(dbUser, (data)=>{
        let user = null;
        if (data.exists()) user = data.val();
        if (user) {
            addPerson(type, key, user, parent);
            if (type == "staff" && currentPerson == 1 || type == "member" && currentPerson == 2) (0, _common.setDisplay)(dNoPeople, "none");
        }
    }, {
        onlyOnce: true
    });
}
function addPerson(type, key, user, parent) {
    let id = type ? `type${key}` : key;
    var dOld = document.getElementById(id);
    const container = document.createElement("div");
    container.innerHTML = (0, _common.list_person);
    const div = container.firstChild;
    div.setAttribute("id", id);
    let imgUser = div.querySelector(".img-user");
    let dName = div.querySelector(".name");
    let btnMore = div.querySelector(".btnMore");
    $(imgUser).on("error", function() {
        imgUser.src = (0, _userSvgDefault.default);
    });
    $(btnMore).off("click");
    $(btnMore).on("click", function() {
    //TODO: show user options
    //view profile
    });
    imgUser.src = user.imgUrl ? user.imgUrl : (0, _userSvgDefault.default);
    dName.textContent = user.name;
    if (dOld) parent.replaceChild(div, dOld);
    else parent.appendChild(div);
}
function addRole() {
    currentPerson;
}
function initChatFrag() {
    if (!user || dbMsg) return;
    dbMsg = (0, _database.ref)((0, _config.db), `msg/${groupId}`);
    dbChat = (0, _database.ref)((0, _config.db), `chat/${groupId}`);
    dbUchat = (0, _database.ref)((0, _config.db), `uChat/${user.uid}/${groupId}`);
    (0, _database.onChildAdded)(dbMsg, (data)=>{
        (0, _common.setDisplay)(dEmptyMsg, "none");
        addMsg(dMsgList, data.key, data.val());
    });
    (0, _database.onChildChanged)(dbMsg, (data)=>{
        addMsg(dMsgList, data.key, data.val());
    });
    (0, _database.onChildRemoved)(dbMsg, (data)=>{
        removeElement(data.key);
        if (dMsgList.children.length == 0) (0, _common.setDisplay)(dEmptyMsg, "block");
    });
    btnSendMsg = document.getElementById("btnSendMsg");
    inMsg = document.getElementById("inMsg");
    $(btnSendMsg).off("click");
    $(btnSendMsg).on("click", function() {
        if (userInfo) checkInput(inMsg.value.trim());
        else {
            let msg = user ? "Finish setting up your profile to participate in the chat" : "Register or login to participate in the chat";
            (0, _common.confirmLoginModal)(msg, `?g=${group.name}`);
        }
    });
//TODO: init send messages
// copy from index.js 408
// and reference MsgFrag Android for extra Msg data to include
}
/**
 * Check if message input is empty or null
 * @param {*} s String input
 */ function checkInput(s) {
    if (s) sendMsg(s);
    else (0, _common.shake)(inMsg);
}
/**
 * Send a new message
 * @param {*} msg Text input
 */ function sendMsg(msg) {
    const key = (0, _database.push)(dbMsg).key;
    if (key) {
        const data = {
            uid: user.uid,
            name: userInfo.name,
            img: userInfo.imgUrl ? userInfo.imgUrl : null,
            chan: groupId,
            key: key,
            type: `txt`,
            msg: msg,
            date: new Date().getTime(),
            chanImg: group.imgUrl ? group.imgUrl : null,
            chanName: group.name
        };
        (0, _database.set)((0, _database.child)(dbMsg, `${key}`), data).then(()=>{
            const recent = {
                date: data.date,
                img: group.imgUrl ? group.imgUrl : null,
                name: group.name,
                type: "group"
            };
            (0, _database.set)(dbUchat, recent);
            inMsg.value = "";
            inMsg.focus();
        }).catch((e)=>{
            console.log("====================================");
            console.log("could not send message: " + e);
            console.log("====================================");
            (0, _common.showToast)("error", "Could not send message");
        });
    }
}
function addMsg(parent, key, msg) {
    var dOld = document.getElementById(key);
    const container = document.createElement("div");
    container.innerHTML = (0, _common.list_msg);
    const div = container.firstChild;
    div.setAttribute("id", key);
    let ivUser = div.querySelector("img");
    let dName = div.querySelector(".name");
    let ivImg = div.querySelector(".msg-content img");
    let dTxt = div.querySelector(".txt");
    let dDate = div.querySelector(".date");
    ivUser.src = msg.img ? msg.img : (0, _userSvgDefault.default);
    dName.textContent = msg.name;
    ivImg.src = msg.mediaUrl ? msg.mediaUrl : (0, _imgSvgDefault.default);
    dTxt.textContent = msg.msg;
    dDate.textContent = (0, _common.formatTime)(msg.date);
    if (dOld) parent.replaceChild(div, dOld);
    else parent.appendChild(div);
}

},{"firebase/auth":"8Nm6e","./common":"loJev","./config":"cl3hM","firebase/database":"gGruC","url:../images/group.svg":"596Ko","url:../images/user.svg":"hrZNT","../images/img.svg":"k2ukq","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"596Ko":[function(require,module,exports) {
module.exports = require("33e268b1d8981f9").getBundleURL("fRtTy") + require("9f14c219bcb44517").resolve("4ZR27");

},{"33e268b1d8981f9":"c7Tr5","9f14c219bcb44517":"fyJL2"}],"c7Tr5":[function(require,module,exports) {
"use strict";
var bundleURL = {};
function getBundleURLCached(id) {
    var value = bundleURL[id];
    if (!value) {
        value = getBundleURL();
        bundleURL[id] = value;
    }
    return value;
}
function getBundleURL() {
    try {
        throw new Error();
    } catch (err) {
        var matches = ("" + err.stack).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g);
        if (matches) // The first two stack frames will be this function and getBundleURLCached.
        // Use the 3rd one, which will be a runtime in the original bundle.
        return getBaseURL(matches[2]);
    }
    return "/";
}
function getBaseURL(url) {
    return ("" + url).replace(/^((?:https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/.+)\/[^/]+$/, "$1") + "/";
}
// TODO: Replace uses with `new URL(url).origin` when ie11 is no longer supported.
function getOrigin(url) {
    var matches = ("" + url).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^/]+/);
    if (!matches) throw new Error("Origin not found");
    return matches[0];
}
exports.getBundleURL = getBundleURLCached;
exports.getBaseURL = getBaseURL;
exports.getOrigin = getOrigin;

},{}],"hrZNT":[function(require,module,exports) {
module.exports = require("c121a2d681f6cffa").getBundleURL("fRtTy") + require("736d45f9608b5c3c").resolve("k8qgN");

},{"c121a2d681f6cffa":"c7Tr5","736d45f9608b5c3c":"fyJL2"}],"k2ukq":[function(require,module,exports) {
module.exports = require("e106127be586d816").getBundleURL("fRtTy") + require("a2679afaf662085").resolve("k5CRO");

},{"e106127be586d816":"c7Tr5","a2679afaf662085":"fyJL2"}]},["fgkIw","3Gn2A"], "3Gn2A", "parcelRequiref9e4")

//# sourceMappingURL=group.a178b09a.js.map
